// components/InterviewCombinedParentIcon.js
import React from "react";
import NotificationProfileRequestBadgeIcon from "components/Sidebar/NotificationProfileRequestBadgeIcon";
import NotificationProfileUpdateResultBadgeIcon from "components/Sidebar/NotificationProfileUpdateBadgeIcon";

const InterviewCombinedParentIcon = () => {
  return (
    <div style={{ position: "relative", display: "inline-block", width: 24, height: 24 }}>
      {/* Base parent icon = requests (sound ON) */}
      <div style={{ position: "absolute", inset: 0 }}>
        <NotificationProfileRequestBadgeIcon playSound={true} iconName="notifications" />
      </div>

      {/* Overlay second badge (result) — sound OFF, thoda offset so badges overlap na ho */}
      <div style={{ position: "absolute", inset: 0, transform: "translate(8px, -8px)" }}>
        <NotificationProfileUpdateResultBadgeIcon playSound={false} />
      </div>
    </div>
  );
};


export default InterviewCombinedParentIcon;
